// 按鈕用的線條圖示（ls-loop 2026-10-11 外觀翻新）：取代 📷 ⏺ 📺 🚨 💡 🎯 🧭 📍 🗖 🗕 這類 emoji，
// 跟 NavIcon / ClusterIcon 同一種線稿；stroke=currentColor，跟著按鈕文字顏色。aria-hidden（旁邊有文字或 aria-label）。
import type { JSX } from 'react';

export type UiIconName = 'camera' | 'record' | 'cast' | 'siren' | 'light' | 'target' | 'compass' | 'pin' | 'maximize' | 'minimize';

const PATHS: Record<UiIconName, JSX.Element> = {
  camera: (
    <>
      <path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
      <circle cx="12" cy="13" r="3.5" />
    </>
  ),
  record: <circle cx="12" cy="12" r="6" fill="currentColor" stroke="none" />,
  cast: (
    <>
      <path d="M3 17a4 4 0 0 1 4 4" />
      <path d="M3 13a8 8 0 0 1 8 8" />
      <path d="M3 9V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-6" />
    </>
  ),
  siren: (
    <>
      <path d="M6 18v-5a6 6 0 0 1 12 0v5" />
      <path d="M4 18h16v3H4z" />
      <path d="M12 3v2M4.5 6.5l1.5 1.5M19.5 6.5 18 8" />
    </>
  ),
  light: (
    <>
      <path d="M9 18h6" />
      <path d="M10 21h4" />
      <path d="M12 3a6 6 0 0 0-3.5 10.9V16h7v-2.1A6 6 0 0 0 12 3z" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3.5" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M15.5 8.5 13.5 13.5 8.5 15.5 10.5 10.5z" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s-6-5.5-6-11a6 6 0 0 1 12 0c0 5.5-6 11-6 11z" />
      <circle cx="12" cy="10" r="2.2" />
    </>
  ),
  maximize: (
    <>
      <path d="M4 9V4h5" />
      <path d="M20 9V4h-5" />
      <path d="M4 15v5h5" />
      <path d="M20 15v5h-5" />
    </>
  ),
  minimize: (
    <>
      <path d="M9 4v5H4" />
      <path d="M15 4v5h5" />
      <path d="M9 20v-5H4" />
      <path d="M15 20v-5h5" />
    </>
  ),
};

export function UiIcon({ name, size = 16 }: { name: UiIconName; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ verticalAlign: '-0.15em', flex: 'none' }}
    >
      {PATHS[name]}
    </svg>
  );
}
